export interface PlaylistTarget {
    loop: boolean;
    mediaIndex: number;
    itemCount: number;
    bundleIndex: number;
    partCount: number;
}

// a lone non-bundle item has nowhere to go, so Next means "replay this" (RMAS-2875)
export const replaysOnNext = (itemCount: number, isBundle: boolean): boolean =>
    itemCount === 1 && !isBundle;

export const replaysOnPrevious = (
    itemCount: number,
    isBundle: boolean,
    bundleIndex: number,
): boolean => itemCount === 1 && (!isBundle || bundleIndex === 0);

export const hasNextPlaylistTarget = ({
    loop,
    mediaIndex,
    itemCount,
    bundleIndex,
    partCount,
}: PlaylistTarget): boolean =>
    !!loop || mediaIndex < itemCount - 1 || bundleIndex < partCount - 1;
